/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ConsumerReviewCard from "./ConsumerReviewCard";

const ConsumerReview = ({
  setReviewModal,
  reviewData,
  setEditReviewDetails,
}) => {
  return (
    <>
      <div className="border border-1 px-4 py-3 rounded-t-2xl mt-4 bg-white">
        <div className="flex justify-between items-center">
          <p className="text-[#284184] text-xl font-bold">Consumer Review</p>
          <button
            className="text-[#E0A256] underline px-3 py-3 rounded-xl text-base flex items-center space-x-1"
            onClick={() => setReviewModal(true)}
          >
            Write a Review
          </button>
        </div>

        {reviewData?.map((res, index) => {
          return (
            <ConsumerReviewCard
              key={index}
              res={res}
              setEditReviewDetails={setEditReviewDetails}
              setReviewModal={setReviewModal}
            />
          );
        })}
      </div>
    </>
  );
};

export default ConsumerReview;
